import http from './http';
import config from 'src/config';

interface ContactFormData {
	name: string;
	email?: string;
	phone?: string;
	subject: string;
	message: string;
}

export const sendContactForm = async (data: ContactFormData): Promise<void> => {
	await http.post(`${config.app.apiURL}/emails/contact`, data);
};
